import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var QuestionBase = t.intersection([t.type({
  id: t.string,
  required: t["boolean"],
  subject: t.string,
  responseIsPublic: t["boolean"]
}), t.partial({
  points: t.number
})]);
export var RadioButtonQuestion = t.intersection([t.type({
  __typename: t.literal('RadioButtonQuestion')
}), QuestionBase, t.type({
  options: t.array(t.type({
    description: t.string
  })),
  currentValue: nullable(t.string)
})]);
export var Question = t.union([t.intersection([t.type({
  __typename: t.literal('CheckboxQuestion')
}), QuestionBase, t.type({
  options: t.array(t.type({
    description: t.string
  })),
  currentValues: nullable(t.array(t.string))
})]), t.intersection([t.type({
  __typename: t.literal('DateQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('DropdownQuestion')
}), QuestionBase, t.type({
  options: t.array(t.type({
    description: t.string
  })),
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('FileUploadQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('VideoUploadQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('LinkQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('LongAnswerQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), RadioButtonQuestion, t.intersection([t.type({
  __typename: t.literal('ImageUploadQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('RatingQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})]), t.intersection([t.type({
  __typename: t.literal('ShortAnswerQuestion')
}), QuestionBase, t.type({
  currentValue: nullable(t.string)
})])]);